var _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2268 10.9021H2.23711C1.82474 10.9433 1 10.8278 1 10.0361V6.07732C1 5.66495 1.19794 4.84021 1.98969 4.84021C2.78144 4.84021 8.58763 4.84021 11.3918 4.84021C11.8454 4.88145 12.7526 5.1866 12.7526 6.07732V9.78866C12.7113 10.1598 12.4557 10.9021 11.7629 10.9021H10.6495",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35059 4.84021V1.5H10.1547V4.59278",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5257 7.93298H3.47412V13.5H10.5257V7.93298Z",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71143 9.91235H9.04132",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71143 11.6443H9.04132",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.85575,
    cy: 6.44847,
    r: 0.371134,
    fill: "#2E77D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.34013,
    cy: 6.44847,
    r: 0.371134,
    fill: "#2E77D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterPrint);
export default __webpack_public_path__ + "static/media/master-print.6c9eef984756999920318a7ede55611c.svg";
export { ForwardRef as ReactComponent };